import React from 'react'
import logo from '../assets/images/logo.png';
// console.log('This' + logo);
// import './index.css'

const LogoComponent = props =>
    <img className={props.class} src={logo} alt="Logo" />

export default LogoComponent



// WEBPACK FOOTER //
// ./src/components/logo.js